import { frontendURL } from '../../../helper/URLHelper';
import { laisCanonicalRedirect } from '../laisRouteHelpers';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/atualizacao'),
    name: 'lais_atualizacao_index',
    redirect: laisCanonicalRedirect('lais_prateleira_atualizacao'),
    meta: { permissions: ['administrator'] },
  },
];
